export default __webpack_public_path__ + "static/media/pic3.ee92ced3.jpg";